module.exports = __webpack_public_path__ + "static/media/lips.76ab6c0e.svg";